import React, { Component, useCallback, useState } from 'react'
import ReactDOMServer from 'react-dom/server'
import RaisedButton from 'material-ui/RaisedButton'
import Dialog from 'material-ui/Dialog'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import FlatButton from 'material-ui/FlatButton'
import numeral from 'numeral'
import Icon from 'react-icons-kit'
import { ic_chevron_left as mdIc_chevron_left } from 'react-icons-kit/md/ic_chevron_left'
import { ic_chevron_right as mdIc_chevron_right } from 'react-icons-kit/md/ic_chevron_right'
import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import { Link } from 'react-router-dom'
import CountTo from 'react-count-to'
import ReactInView from 'react-inview-js'
import isBefore from 'date-fns/isBefore'
import ReCAPTCHA from 'react-google-recaptcha'
import format from 'date-fns/format'
import axios from 'axios'

import AspectRatio from '../AspectRatio'
import BreakPoint from '../../responsive-utilities/breakpoint'
import renderContent from '../../utilities/renderContent'
//import imgPoster from './poster.png'
import imgPortrait from './portrait.png'
//import backgroundShade from '../../assets/img/shade2.png'
import slide1 from './slides/1.png'
import slide2 from './slides/2-2.png'
import slide3 from './slides/3.png'

import _201812_1 from './slides/201812/3.png'
import _201812_pdf from './slides/201812/AY_Skin_Specialist_Clinic_Xmas_2018.pdf'
// import slide20180106 from './slides/20180106.jpg'
import './style.css'
import useStateObject from '../../hooks/useStateObject.js'

const randomNumber = (min = 100, max = 200000) => Math.floor(Math.random() * (max - min) + min)

//const OwlCarousel = () => <div></div>

class Counter extends Component {
  constructor(props) {
    super(props)

    this.elementHasBeenInView = false
  }

  render() {
    const {
      to,
      speed,
      elementIsInView,
      //elementHasBeenInView,
    } = this.props

    if (this.elementHasBeenInView) {
      return (
        <div>
          {numeral(to).format('0,0')}
        </div>
      )
    }

    if (elementIsInView) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        clearTimeout(this.timeout)
        this.elementHasBeenInView = true
      }, speed)

      return (
        <CountTo to={to} speed={speed}>
          {
            (value) => (
              <div>
                {numeral(value).format('0,0')}
              </div>
            )
          }
        </CountTo>
      )
    }

    return (
      <div>0</div>
    )
  }
}

Counter = ReactInView({
  showGuides: false,
  offsetY: 0,
  fullElementInView: true,
})(Counter)

class Home extends Component {
  render() {
    const { data } = this.props
    const featuredDoctorKey = 'dr-adam-yusof'
    const featuredDoctor = data.doctors[featuredDoctorKey]
    const navText = [
      ReactDOMServer.renderToStaticMarkup(
        <Icon icon={mdIc_chevron_left} size={24} />
      ),
      ReactDOMServer.renderToStaticMarkup(
        <Icon icon={mdIc_chevron_right} size={24} />
      ),
    ]
    const commonConditions = {
      'skin-cancer': {
        name: data.conditions.dermatology.child['skin-cancer'].name,
        description: data.conditions.dermatology.child['skin-cancer'].description,
        image: data.conditions.dermatology.child['skin-cancer'].images[0],
        link: '/conditions/dermatology/skin-cancer',
      },
      'allergy': {
        name: data.conditions.dermatology.child['allergy'].name,
        description: data.conditions.dermatology.child['allergy'].description,
        image: data.conditions.dermatology.child['allergy'].images[0],
        link: '/conditions/dermatology/allergy',
      },
      'acne': {
        name: data.conditions.dermatology.child['acne'].name,
        description: data.conditions.dermatology.child['acne'].description,
        image: data.conditions.dermatology.child['acne'].images[0],
        link: '/conditions/dermatology/acne'
      },
      'pigmentation': {
        name: data.conditions.aesthetics.child['pigmentation-problems'].name,
        description: data.conditions.aesthetics.child['pigmentation-problems'].description,
        image: data.conditions.aesthetics.child['pigmentation-problems'].images[0],
        link: '/conditions/aesthetics/pigmentation-problems',
      },
    }

    // console.log('commonConditions', commonConditions)
    const today = new Date()
    const mcoEnd = new Date('2020-05-05T00:00:00')

    return (
      <div className="home">
        <div className="container">
          {isBefore(today, mcoEnd) &&
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{
                border: '0.25rem #2a3890 solid',
                boxShadow: '0 1rem 3rem rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                margin: '1rem 1rem 2rem',
                padding: '0 1rem',
                color: '#000',
              }}>
                <h2 style={{ textAlign: 'center' }}>Announcement</h2>
                <p>
                  Good day. AY Skin Specialist Clinic is opened during the MCO from 9:45 am to 1 pm daily except Sundays, with the exception of Tuesdays 1 pm to 4 pm.
              </p>
                <p>
                  Please make an appointment beforehand to help us space out attendances.
              </p>
                <p>
                  Alternatively if you would like to have a video consultation, please click on the button below.
              </p>
                <div style={{ textAlign: 'center' }}>
                  <OnlineConsultation data={data} />
                  {/* <Link to="/appointment?type=online">
                    <RaisedButton
                      primary={true}
                      className="big"
                      label="Book Online Consultation"
                      style={{ marginBottom: '1rem' }}
                    />
                  </Link> */}
                </div>
              </div>
            </div>
          }
          <OwlCarousel
            className="owl-theme"
            items={1}
            navText={navText}
            navSpeed={400}
            dotsSpeed={400}
            smartSpeed={400}
            animateIn="fadeIn"
            animateOut="fadeOut"
            mouseDrag={true}
            touchDrag={true}
            autoplay={true}
            autoplaySpeed={5000}
            loop
            autoplayHoverPause={true}
            nav={true}
            dots={false}
          >
            {/*
              <div>
                <Link to="/contact">
                  <div className="item">
                    <div className="content"
                      style={{
                        padding: 0,
                      }}
                    >
                      <div className="right" style={{
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: `url('${slide20180106}')`,
                        flex: 1,
                      }}>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            */}

            {false &&
              <div>
                <div className="item">
                  <div className="content">
                    <div className="center" style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'right',
                      margin: '0 16px',
                    }}>
                      <div className="poster-text" style={{}}>
                        <h1 className="" style={{
                          margin: 0,
                          textTransform: 'uppercase',
                          color: '#2a3890',
                          fontWeight: 'bolder',
                        }}>
                          Christmas 2018 Promotion
                        </h1>
                        <h2 style={{
                          color: '#cb9200',
                          fontFamily: 'Allura, sans-serif',
                          fontWeight: 'lighter',
                        }}>
                          ‘Tis the season to look Always Young
                        </h2>
                        <p className="">
                          <a href={_201812_pdf} target="_blank" rel="noopener">
                            <RaisedButton
                              primary={true}
                              label="Learn More"
                              style={{ backgroundColor: 'transparent' }}
                            />
                          </a>
                        </p>
                      </div>
                    </div>
                    <div className="right" style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundPosition: 'center center',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundImage: `url('${_201812_1}')`,
                    }}>
                    </div>
                  </div>
                </div>
              </div>
            }

            {true &&
              <div>
                <div className="item item-1">
                  <div className="content">
                    <div className="center" style={{ justifyContent: 'center' }}>
                      <div className="poster-text" style={{ textAlign: 'right' }}>
                        <h1 className="tagline">
                          Prompt & Professional
                        </h1>
                        <p className="sub">
                          We aim to address your concerns in a
                          <br />
                          prompt & professional manner.
                        </p>
                      </div>
                    </div>
                    <div className="right" style={{
                      justifyContent: 'flex-end',
                      backgroundPosition: 'center bottom',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundImage: `url('${slide2}')`,
                    }}>
                    </div>
                  </div>
                </div>
              </div>
            }

            {
              <div>
                <div className="item item-2">
                  <div className="content">
                    <div className="center" style={{ justifyContent: 'center' }}>
                      <div className="poster-text" style={{ textAlign: 'center' }}>
                        <h1 className="tagline">
                          No Problem is Too Difficult
                        </h1>
                        <p className="sub">
                          We believe that no problem is too difficult.
                        </p>
                        <ul className="links">
                          <li>
                            <Link to="/treatments/mohs-micrographic-surgery">
                              Mohs Micrographic Surgery
                            </Link>
                          </li>
                          <li>
                            <Link to="/conditions/dermatology/allergy">
                              Allergy
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/phototherapy">
                              Phototherapy
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/nail-surgery">
                              Nail Surgery
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="right" style={{
                      backgroundPosition: 'center bottom',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundImage: `url('${slide3}')`,
                      flex: 1,
                    }}>
                    </div>
                  </div>
                </div>
              </div>
            }

            {true &&
              <div>
                <div className="item item-3">
                  <div className="content">
                    <div className="left" style={{
                      justifyContent: 'flex-end',
                      backgroundPosition: 'center bottom',
                      backgroundSize: 'contain',
                      backgroundRepeat: 'no-repeat',
                      backgroundImage: `url('${slide1}')`,
                    }}>
                    </div>
                    <div className="center" style={{ justifyContent: 'center' }}>
                      <div className="poster-text">
                        <h1 className="tagline">
                          Always Young
                        </h1>
                        <p className="sub">
                          We aim to restore your confidence by keeping you <span className="tagline">always young</span>.
                        </p>
                        <ul className="links">
                          <li>
                            <Link to="/treatments/botulinum-toxin-&-fillers">
                              Botulinum Toxin & Fillers
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/laser">
                              Laser
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/mesotherapy">
                              Mesotherapy
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/medical-grade-skin-peels">
                              Skin Peels
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/platelet-rich-plasma">
                              Platelet Rich Plasma
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/high-intensity-focused-ultrasound">
                              High Intensity Focused Ultrasound (HIFU)
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/cryolipolysis">
                              Cryolipolysis (Fat Freezing)
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/korean-hydrafacial">
                              Korean Hydrafacial
                            </Link>
                          </li>
                          <li>
                            <Link to="/treatments/korean-threadlift">
                              Korean Threadlift
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

          </OwlCarousel>
        </div>
        {/*
        <div className="section-poster">
          <div className="container">
            <div className="content">
              <div className="left">
                <div className="poster-text">
                  <p className="tagline">
                    Marketing
                    <br />
                    Message
                  </p>
                  <p className="sub">
                    Some Short Description
                  </p>
                </div>
              </div>
              <div className="right">
                <img src={imgPoster} className="image-poster" draggable="false" alt={data.name} />
              </div>
            </div>
          </div>
        </div>
        */}
        <div className="section">
          <div className="section-bg"></div>
          <div className="section-bg"></div>
          <div className="section-intro">
            <div className="container">
              <div className="content">
                <div className="left">
                  <img src={imgPortrait} className="image-portrait" draggable="false" alt={featuredDoctor.name} />
                </div>
                <div className="right">
                  <h1 className="title">Dr. Adrian Yong Sze Wai</h1>
                  <h4 className="subtitle">Consultant Dermatologist & Dermatological Surgeon</h4>
                  {
                    <h4 className="subtitle2">BSc(Hons), MBBS(London), MRCP(UK) (CCT Dermatology UK)</h4>
                  }
                  <hr className="divider" />
                  <div className="description">
                    {/* <ul>
                      <li>
                        UK Consultant Dermatologist Returning Expert Program Talentcorp 2015
                      </li>
                      <li>
                        Associate Professor & Head of Dermatology, University Malaya Medical Centre 2016-2017
                      </li>
                      <li>
                        Previous Visiting Consultant Dermatologist University Malaya Specialist Centre (UMSC) 2015-2017
                      </li>
                      <li>
                        Malaysia National Specialist Registered Consultant Dermatologist (NSR 130706)
                      </li>
                      <li>
                        Certificate of Completion of Training in Dermatology United Kingdom MRCP (UK) (Dermatology)
                      </li>
                      <li>
                        Member of the Main Committee of the Letter of Credentialing and Privileging for Aesthetic Medicine 2017/18
                      </li>
                      <li>
                        Chairman of Malaysia Urticaria Expert Group (MARTEG)
                      </li>
                    </ul> */}
                    <p className="title">Qualification &amp; Specialty</p>
                    <ul>
                      <li>
                        Malaysia National Specialist Registered Consultant Dermatologist (NSR 130706)
                      </li>
                      <li>
                        Royal Colleges of Physicians of the United Kingdom MRCP (UK) (Dermatology)
                      </li>
                      <li>
                        Letter of Credentialing and Privileging for Aesthetic Medical Practice LCP-AMP-002/2016(1)
                      </li>
                      <li>
                        Malaysian Medical Council Full Registraion (No. 63950), Graduate of MBBS (University of London)
                      </li>
                    </ul>
                  </div>
                  <p className="branding-tagline">
                    Look and feel
                    <br />
                    <span className="tagline">
                      Always Young
                    </span>
                  </p>
                  <Link to="/about">
                    <RaisedButton primary={true} label="Biography" style={{ backgroundColor: 'transparent' }} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="section-services">
            <div className="container">
              <h1>Services</h1>
              <div className="content">
                <ul>
                  <li>MOHs micrographic and Dermatological Surgery including flaps and grafts</li>
                  <li>Skin allergy diagnostics including skin patch test and allergen protein detection</li>
                  <li>Cosmetic dermatology</li>
                  <li>Pigmentary problems (laser and phototherapy)</li>
                  <li>Hair regrowth package</li>
                  <li>Permanent hair reduction laser</li>
                  <li>Thread and varicose vein laser and sclerotherapy injection</li>
                  <li>Nail discolouration, deformity and cancer (laser and surgery)</li>
                  <li>Facial rejuvenation Botulinum toxin, Fillers, Threads, Highl intensity focused ultrasound (HIFU)</li>
                  <li>Skin infection including viral warts, herpes skin infection, impetigo, cellulitis, boils and abscess</li>
                  <li>Inflammatory skin conditions include eczema, psoriasis, acne, rosacea</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="section-featured">
            <div className="container">
              <h1>Common Conditions</h1>
              <div className="content">
                <div className="tile-container">
                  {Object.keys(commonConditions).map((key, index) => {
                    const condition = commonConditions[key]

                    return (
                      <div key={`${key}-${index}`}>
                        <div className="tile">
                          <div style={{
                            backgroundImage: `url(${condition.image})`,
                            backgroundSize: 'cover',
                          }}>
                            <AspectRatio aspectRatio={4 / 3} />
                          </div>
                          <div className="tile-content">
                            <div className="title">
                              {condition.name}
                            </div>
                            <div>
                              {condition.description}
                            </div>
                          </div>
                          <div className="tile-footer">
                            <Link to={condition.link}>
                              <RaisedButton primary={true} label="Learn More" style={{ backgroundColor: 'transparent' }} />
                            </Link>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          {false &&
            <div className="section-infographic">
              <div className="container">
                <div className="content">
                  <div className="infographic">
                    <Counter to={randomNumber(100, 800)} speed={randomNumber(1000, 3000)} />
                  </div>
                  <div className="infographic">
                    <Counter to={randomNumber(3000, 20000)} speed={randomNumber(1000, 3000)} />
                  </div>
                  <div className="infographic">
                    <Counter to={randomNumber(50000, 200000)} speed={randomNumber(1000, 3000)} />
                  </div>
                  <div className="infographic">
                    <Counter to={randomNumber(10000, 60000)} speed={randomNumber(1000, 3000)} />
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

const OnlineConsultation = ({ data }) => {
  const [submitting, setSubmitting] = useState(false)
  const open = useStateObject(false)
  const name = useStateObject('', {
    validator: state => !state && 'Name is required',
  })
  const email = useStateObject('', {
    validator: state => !state && 'Email is required.',
  })
  const phone = useStateObject('', {
    validator: state => !state && 'Phone is required.',
  })
  const newOld = useStateObject('N', {
    validator: state => !state && 'Phone is required.',
  })
  const message = useStateObject('')
  const receipt = useStateObject(null, {
    validator: state => !state && 'Receipt is required.'
  })
  const recaptcha = useStateObject()
  const makeOnChange = useCallback(stateObject => (event, value) => {
    stateObject.setState(value)
    stateObject.setError(null)
  })
  const makeOnChangeNewOld = useCallback((event, index, value) => newOld.setState(value))
  const receiptOnChange = useCallback(() => {
    const newState = (receipt.ref.current.files && receipt.ref.current.files[0]) || null
    receipt.setState(newState)
    receipt.setError((!newState && 'Receipt is required') || false)
  }, [])
  const submitBooking = useCallback(async () => {
    const fields = [name, email, phone, newOld, receipt]
    const errors = fields.map(f => f.error).filter(Boolean)
    // console.log({ errors })

    if (errors.length) { return }
    setSubmitting(true)

    const formData = new FormData()
    formData.append('name', name.state)
    formData.append('email', email.state)
    formData.append('phone', phone.state)
    formData.append('new_old', newOld.state)
    formData.append('message', message.state)
    formData.append('recaptchaResponse', recaptcha.state)
    formData.append('receipt', receipt.state)

    console.log({
      name: name.state,
      email: email.state,
      phone: phone.state,
      new_old: newOld.state,
      message: message.state,
      recaptchaResponse: recaptcha.state,
      receipt: receipt.state,
    })

    const url = [
      data.api.endpoint,
      'online-consultation',
    ].join('/')

    let res

    try {
      res = await axios.post(url, formData)
    } catch (error) {
      alert('Connection error, please try again.')
      setSubmitting(false)
      return console.log('POST', url, { error })
    }
    setSubmitting(false)
    recaptcha.ref.current.reset()

    if (res.data.error) {
      let errorMessage = res.data.error.message
      if (res.data.errors) {
        errorMessage += '\n'
        errorMessage += Object.values(res.data.errors).join('\n')
      }
      return alert(errorMessage)
    }
    if (res.data.success) {
      alert(res.data.success.message)

      open.setState(false)

      // Event snippet for Ay Clinic- appointment booking conversion page
      if (window.gtag) {
        window.gtag('event', 'conversion', { 'send_to': 'AW-821680649/wH_LCMvcjnsQibTnhwM' })
      } else {
        console.log('gtag not available', window)
      }
    }

    name.setState('')
    email.setState('')
    phone.setState('')
    newOld.setState('')
    message.setState('')
    recaptcha.setState(null)
  }, [name.state, email.state, phone.state, newOld.state, message.state, recaptcha.state])
  return (
    <div>
      <RaisedButton
        primary={true}
        className="big"
        label="Book Online Consultation"
        style={{ marginBottom: '1rem' }}
        onClick={open.make(open.setState, true)}
      />
      <Dialog
        title="Book Online Consultation"
        id="AppointmentFormDialog"
        titleStyle={{
          textAlign: 'center',
        }}
        autoScrollBodyContent={true}
        open={open.state}
        contentStyle={{
          maxWidth: 'calc(100vw - 2rem)',
          width: '50rem',
        }}
        onRequestClose={open.make(open.setState, false)}
      >
        <TextField
          floatingLabelText="Name"
          hintText="Your Name"
          autoFocus={true}
          onChange={makeOnChange(name)}
          floatingLabelFixed={true}
          fullWidth={true}
          errorText={name.error}
          value={name.state}
        />
        <TextField
          floatingLabelText="Email"
          hintText="Email Address"
          onChange={makeOnChange(email)}
          floatingLabelFixed={true}
          fullWidth={true}
          type="email"
          errorText={email.error}
          value={email.state}
        />
        <TextField
          floatingLabelText="Phone"
          hintText="Contact Number"
          onChange={makeOnChange(phone)}
          floatingLabelFixed={true}
          fullWidth={true}
          errorText={phone.error}
          value={phone.state}
        />
        <SelectField
          floatingLabelText="I am a"
          value={newOld.state}
          fullWidth={true}
          onChange={makeOnChangeNewOld}
        >
          <MenuItem value="N" primaryText="New Patient" />
          <MenuItem value="F" primaryText="Follow-up Patient" />
        </SelectField>
        <TextField
          floatingLabelText="Purpose of Appointment"
          hintText="What is the appointment about?"
          onChange={makeOnChange(message)}
          floatingLabelFixed={true}
          multiLine={true}
          rowsMax={2}
          maxLength={60}
          fullWidth={true}
          value={message.state}
        />
        <div style={{
          fontSize: '.75rem',
          textAlign: 'right',
          fontStyle: 'italic',
          color: '#aaa',
        }}>
          {`${message.state.length}/60`}
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <div style={{
            color: '#2a3890',
            border: '0.25rem #2a3890 solid',
            boxShadow: '0 1rem 3rem rgba(0, 0, 0, 0.1)',
            backgroundColor: '#fff',
            margin: '1rem 1rem 2rem',
            padding: '0 1rem',
          }}>
            <p>
              If you would like to proceed to request an online consultation,
                the charge would be <strong>RM 100</strong> payable by online transfer
                (discounted normal specialist rate of up to RM 230 as stipulated by the Malaysian Medical Association)
              </p>
            <p>
              Please kindly make the payment to:
              </p>
            <dl>
              <dt><strong>Bank</strong></dt>
              <dd>CIMB</dd>
              <dt><strong>Account Name</strong></dt>
              <dd>AY Skin Specialist & Aesthetic Centre PLT</dd>
              <dt><strong>Account Number</strong></dt>
              <dd>800 827 4646</dd>
            </dl>
            <p>
              Please attach your payment receipt below.
              </p>
          </div>
          <div>
            <label style={{ fontSize: '0.75rem', color: '#2a3890' }}>Bank Payment Receipt</label>
          </div>
          <div style={{ margin: '.25rem 0' }}>
            <input type="file" ref={receipt.ref} onChange={receiptOnChange} />
          </div>
          {!!receipt.error ? (
            <div style={{ fontSize: '0.75rem', color: 'red' }}>{receipt.error}</div>
          ) : (
              <div style={{ fontSize: '0.75rem' }}>
                Upload your bank payment receipt here
              </div>
            )}
        </div>
        <ReCAPTCHA
          ref={recaptcha.ref}
          sitekey={data.recaptcha.sitekey}
          size="normal"
          className="recaptcha-container"
          onChange={recaptcha.setState}
          badge="inline"
        />
        <div style={{
          paddingTop: '2rem',
          textAlign: 'right',
        }}>
          <FlatButton label="Cancel"
            onClick={open.make(open.setState, false)}
          />
          <FlatButton label="Submit"
            primary={true}
            onClick={submitBooking}
            disabled={!name.state || !email.state || !phone.state || !newOld.state || !recaptcha.state || submitting}
          />
        </div>
      </Dialog>
    </div>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/index.js